import { RealtimeService } from '@/services/realtime-service';
import { bellNotifications } from '@/services/realtime-service/subscriptions';

export default {
  install: (app) => {
    const {
      _context: { provides },
    } = app;
    const realtime = new RealtimeService(provides);

    // realtime.subscribeToUserChannel(toastNotifications(provides));
    realtime.subscribeToUserChannel(bellNotifications(provides));

    app.provide('realtime', realtime);
  },
};
